import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
import { Link } from 'react-router-dom';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative py-32 flex items-center justify-center overflow-hidden" data-id="element-38">
      {/* Background Image with Heavy Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/nm2vvmbFNr7jJiMfCXYQ18/Gemini_Generated_Image_1prdd51prdd51prd.png")'
    }} data-id="element-39" />
      <div className="absolute inset-0 z-10 bg-navy/80 backdrop-blur-sm" data-id="element-40" />

      <div className="relative z-20 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} data-id="element-42">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading text-warmWhite mb-12 leading-tight" data-id="element-43">
            {t('finalCta.headline1')}{' '}
            <span className="text-saffron italic" data-id="element-44">
              {t('finalCta.headline2')}
            </span>
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-20" data-id="element-45">
            <a href="https://form.typeform.com/to/BGQF1C1p" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-saffron text-navy rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-warmWhite transition-colors duration-300 shadow-lg hover:shadow-xl text-center" data-id="element-46">
              {t('finalCta.cta1')}
            </a>
            <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-warmWhite/50 text-warmWhite rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-warmWhite/10 hover:border-warmWhite transition-colors duration-300 text-center" data-id="element-47">
              {t('finalCta.cta2')}
            </a>
          </div>

          <div className="mt-12 pt-12 border-t border-warmWhite/10 text-warmWhite/60 text-sm" data-id="element-48">
            <p data-id="element-49">
              For large donations or corporate sponsorships, please{' '}
              <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="text-saffron hover:text-warmWhite transition-colors" data-id="element-50">
                contact us directly
              </a>
              .
            </p>
          </div>
        </motion.div>

        {/* Footer */}
        <div className="border-t border-warmWhite/20 pt-8 flex flex-col md:flex-row justify-between items-center text-warmWhite/50 text-sm" data-id="element-51">
          <p data-id="element-52">{t('finalCta.copyright')}</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-53">
            <Link to="/pitch-deck" className="hover:text-warmWhite transition-colors" data-id="element-54">
              {t('finalCta.pitchDeck')}
            </Link>
            <a href="#" className="hover:text-warmWhite transition-colors" data-id="element-55">
              {t('finalCta.contact')}
            </a>
            <a href="#" className="hover:text-warmWhite transition-colors" data-id="element-56">
              {t('finalCta.inquiries')}
            </a>
            <a href="#" className="hover:text-warmWhite transition-colors" data-id="element-57">
              {t('finalCta.privacy')}
            </a>
          </div>
        </div>
      </div>
    </section>;
}